import {
  MdCropSquare,
  MdDoneAll,
  MdOpenInNew,
  MdOutlineAdd,
  MdOutlineAutoGraph,
  MdOutlineBlock,
  MdOutlineCheck,
  MdOutlineClose,
  MdOutlineDescription,
  MdOutlineEmojiEmotions,
  MdOutlineFavoriteBorder,
  MdOutlineFlag,
  MdOutlineGroup,
  MdOutlineGroups,
  MdOutlineHome,
  MdOutlineList,
  MdOutlineLiveHelp,
  MdOutlineMail,
  MdOutlineMessage,
  MdOutlinePendingActions,
  MdOutlineSchool,
  MdOutlineSearch,
  MdOutlineSettings,
  MdOutlineTask,
  MdOutlineTrackChanges,
  MdOutlineWarningAmber,
  MdOutlineWhatsapp,
  MdQueryStats,
} from 'react-icons/md'

export const iconsMap = {
  home: MdOutlineHome,
  queryStats: MdQueryStats,
  pendingActions: MdOutlinePendingActions,
  description: MdOutlineDescription,
  groups: MdOutlineGroups,
  list: MdOutlineList,
  flag: MdOutlineFlag,
  favoriteBorder: MdOutlineFavoriteBorder,
  cropSquare: MdCropSquare,
  emojiEmotions: MdOutlineEmojiEmotions,
  task: MdOutlineTask,
  settings: MdOutlineSettings,
  school: MdOutlineSchool,
  whatsapp: MdOutlineWhatsapp,
  openInNew: MdOpenInNew,
  add: MdOutlineAdd,
  doneAll: MdDoneAll,
  message: MdOutlineMessage,
  close: MdOutlineClose,
  warningAmber: MdOutlineWarningAmber,
  group: MdOutlineGroup,
  autoGraph: MdOutlineAutoGraph,
  liveHelp: MdOutlineLiveHelp,
  mail: MdOutlineMail,
  block: MdOutlineBlock,
  check: MdOutlineCheck,
  search: MdOutlineSearch,
  trackChanges: MdOutlineTrackChanges,
} as const

export type IconName = keyof typeof iconsMap
export const iconNames: [IconName, ...IconName[]] = Object.keys(iconsMap) as [
  IconName,
  ...IconName[],
]
